import { defineComponent, PropType } from "@vue/composition-api";
import { getNameMimeType } from "@scrile/tools/dist/lib/FileHelpers";

interface ConfigFileType {
  image: string[];
  video: string[];
  audio: string[];
  document: string[];
}

export default function InputFileMixin(configFileTypes: ConfigFileType) {
  type FileTypeKeys = keyof typeof configFileTypes;

  const normalizeAcceptType = (type: string) => (type === "photo" ? "image" : type);
  const isConfigAcceptType = (type: string): type is FileTypeKeys => {
    return Object.keys(configFileTypes).includes(type);
  };
  let configMimeTypes: Record<string, string[]> = {};

  for (let type in configFileTypes) {
    if (isConfigAcceptType(type)) {
      configMimeTypes[type] = configFileTypes[type].reduce<string[]>((acc, i) => {
        acc.push("." + i);
        acc.push(getNameMimeType(i));
        return acc;
      }, []);
    }
  }

  return defineComponent({
    name: "InputFileMixin",
    props: {
      accept: { type: [Array, String] as PropType<string | Array<string>> },
    },
    computed: {
      acceptTypes(): string {
        if (!this.accept) return "*/*";
        let accept: string[] = Array.isArray(this.accept) ? this.accept : [this.accept];

        return accept
          .map(t => {
            t = normalizeAcceptType(t);
            if (isConfigAcceptType(t)) return Array.from(new Set(configMimeTypes[t])).join(", ");
            const res = [t];
            if (t.lastIndexOf(".") > 0 && t.indexOf("/") === -1) res.push(getNameMimeType(t));
            return res.join(", ");
          })
          .join(", ");
      },
    },
  });
}
